import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	composedIcon: {
		width: "30px",
		minWidth: "30px",
		position: "relative",
		height: "30px",
		color: tokens.colorNeutralForeground3,
	},
	iconContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& svg": {
			fontSize: "22px",
		},
	},
	upperIcon: {
		position: "absolute",
		right: 0,
		top: 0,
		width: "13px",
		height: "13px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	middleIcon: {
		position: "absolute",
		right: "10px",
		top: "7px",
	},
	middleIconCentered: {
		top: "1px",
		right: "2px",
	},
	bottomIcon: {
		position: "absolute",
		left: 0,
		bottom: 0,
		width: "20px",
		height: "20px",
	},
	bottomIconCentered: {
		top: 0,
		right: 0,
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& svg": {
			fontSize: "24px",
			width: "24px",
			height: "24px",
		},
	},
	highlighted: {
		"& svg": {
			color: tokens.colorNeutralForeground3BrandHover,
		},
	},
	bold: {
		fontWeight: "bold"
	},
	redHighlight: {
		"& svg": {
			color: tokens.colorPaletteRedForeground1,
		},
	},
	largeSizeIcon: {
		"& svg": {
			fontSize: "28px",
		},
	}
});
